import React from "react";
import { KpiIcon } from "../KpiIcons";
import { OPEN, PARTIAL } from "../../../KpiLock/helpers";

/**
 * Marks a KPI whose due date has passed.
 *
 * A partial lock is shown in a softer amber than a full one: some locations are
 * still open, so the row is a warning rather than a closed door.
 * @param {object} props
 * @param {object} props.lock the KPI's summarised lock state.
 * @returns {JSX.Element|null} the badge, or nothing when the KPI is open.
 */
const LockBadge = ({ lock }) => {
  if (!lock || lock.status === OPEN) return null;
  const isPartial = lock.status === PARTIAL;
  const label = isPartial
    ? `Locked at ${lock.lockedLocationIds.length} location${lock.lockedLocationIds.length > 1 ? "s" : ""}`
    : "Locked";
  return (
    <span
      title={`Closed for entry on ${lock.dueDate}. Request access from an administrator to reopen it.`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        marginLeft: 8,
        padding: "1px 7px",
        borderRadius: 10,
        verticalAlign: "middle",
        fontSize: 10.5,
        fontWeight: 600,
        fontFamily: "var(--font-mono)",
        color: isPartial ? "#92400e" : "#9f1239",
        background: isPartial ? "#fef3c7" : "#ffe4e6",
        border: `1px solid ${isPartial ? "#fcd34d" : "#fda4af"}`,
      }}
    >
      <KpiIcon name="lock" size={9} color={isPartial ? "#92400e" : "#9f1239"} />
      {label}
    </span>
  );
};

export default LockBadge;
